import React from 'react';

// 데이터가 없을 경우 빈 데이터를 제공
const emptyData = {
  PM2: '',
  PM3: '',
  합계: '',
};

// 각 카테고리에 대해 필요한 데이터를 자동으로 채워주는 함수
const getDataByCategory = (category, data) => {
  const foundData = data.find(item => item.category === category);
  return foundData
    ? {
        PM2: foundData.PM2 || '',
        PM3: foundData.PM3 || '',
        합계: foundData.합계 || '',
      }
    : emptyData;
};

const FirstContainer = ({ data = [] }) => {
  // 카테고리 리스트 (상위 헤더)
  const categories = ['구분', '일목표량', '실생산량', '과부족', '이론생산량', '제품율(%)', '월누계', '월목표'];

  // 각 카테고리별 데이터를 가져옴
  const formattedData = categories.map(category => ({
    category,
    ...getDataByCategory(category, data),
  }));

  return (
    <div className='mb-8 text-xxs sm:text-xs md:text-sm lg:text-lg xl:text-xl border border-black'>
      <div className='flex w-full'>
        {/* 구분과 생산량(Ton) */}
        <div className='flex flex-col w-[12%] border border-black'>
          <div className='bg-blue-200 h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b-2 border-black'>
            {categories[0]}
          </div>
          <div className='bg-blue-200 h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center'>
            생산량
            <br />
            (Ton)
          </div>
        </div>

        {/* 호기와 데이터 셀들 */}
        {formattedData.map((row, index) => (
          <div key={index} className='flex flex-col w-[12%] border border-black'>
            <div
              className={`h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black`}
            >
              {index === 0 ? '호기' : row.category}
            </div>
            {index === 0 ? (
              <>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'>
                  PM2
                </div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'>
                  PM3
                </div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'>
                  합계
                </div>
              </>
            ) : (
              <>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'>
                  {row.PM2 || ''}
                </div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'>
                  {row.PM3 || ''}
                </div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'>
                  {row.합계 || ''}
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FirstContainer;
